import React from "react";
import AddRoleContents from "../../constants/contentFile.json";
import "./addRole.css";
import TextInput from "../TextInputComponent/TextInput";
import Button from "../ButtonComponent/Button";

const AddRole = ({
  submitAddRole,
  roleName,
  setRoleName,
  addOrEdit,
  showRoleNameRequiredError,
  onChangeInput,
}) => {
  const addRoleConstants = AddRoleContents.addRole;

  return (
    <div className="addRoleOuterContainer">
      <div className="AddNewRoleContainer">
        <span className="AddNewRoleText">{addOrEdit}</span>
      </div>
      <div className={showRoleNameRequiredError === true ? "error" : null}>
        <TextInput
          placeholder={roleName}
          value={roleName}
          onChange={onChangeInput}
        />
      </div>
      <Button
        text={addRoleConstants.submit}
        onClick={() => {
          submitAddRole();
        }}
      />
    </div>
  );
};

export default AddRole;
